import { inject } from '@angular/core';
import { CanMatchFn, Route, Router, UrlSegment } from '@angular/router';
import { of } from 'rxjs';
import { OrderStorageService } from '../order-storage.service';

export const checkoutSuccessGuard: CanMatchFn = (
  _route: Route,
  _segments: UrlSegment[],
) => {
  const router = inject(Router);
  const orderStorage = inject(OrderStorageService);

  const orderToken = _segments[0].path;

  if (!orderToken) {
    return router.createUrlTree(['/']);
  }

  const order = orderStorage.order();

  if (!order) {
    return router.createUrlTree(['/']);
  }

  if (order.token !== orderToken) {
    return router.createUrlTree(['/']);
  }

  if (orderStorage.isExpired()) {
    orderStorage.clearOrder();
    return router.createUrlTree(['/']);
  }

  return of(true);
};
